import React from "react";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { ScheduleFrequencyOptions } from "constants/reportSubscriptions";
import FieldLabel from "./FieldLabel";

const useStyles = makeStyles()(() => ({
	group: {
		display: "flex",
		flexDirection: "row",
		gap: "16px",
	},
}));

const FrequencyRadioGroup = ({ value, onChange }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			<FieldLabel required>{t("label.frequency")}</FieldLabel>
			<RadioGroup
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className={classes.group}
			>
				{ScheduleFrequencyOptions().map((opt) => (
					<FormControlLabel
						key={opt.value}
						value={opt.value}
						control={<Radio />}
						label={opt.label}
					/>
				))}
			</RadioGroup>
		</div>
	);
};

export default FrequencyRadioGroup;
